module.exports = __webpack_public_path__ + "static/media/amit.986a3739.png";